<template>
  <div class="news_detail-page">

    <!-- 搜索弹窗 -->
    <div class="search" v-show="searchVisible">
      <div class="sc_bj">
        <div class="sc_gb" @click="toggleSearch"><i class="iconfont icon-guanbi1"></i></div>
        <div class="sc_nr">
          <input type="text" v-model="searchKeyword" placeholder="Please enter keywords">
          <button @click="handleSearch"><i class="iconfont icon-tubiaozhizuomoban"></i></button>
          <div class="clear"></div>
        </div>
      </div>
    </div>

    <!-- 新闻详情主体 -->
    <div class="xw_xq">
      <div class="container">
        <!-- 新闻头图 -->
        <div class="xw_dt">
          <img :src="`https://cdn.bosscaigou.com/${newsDetail.himg}`" alt="">
        </div>

        <!-- 新闻内容 -->
        <div class="xw_nr">
          <div class="row">
            <!-- 主要内容区 -->
            <div class="nr_wz">
              <!-- 位置导航 -->
              <div class="l_m"><i class="iconfont icon-dizhi1"></i> <a href="/">Home</a> - <a href="/news">News</a>
              </div>

              <!-- 新闻标题 -->
              <h1>{{ newsDetail.title }}</h1>

              <!-- 发布信息 -->
              <div class="f_b">
                <span>Time: {{ initTime(newsDetail.ctime) }}</span>
                <span>Source: <a :href="'/'">Honor</a></span>
              </div>

              <!-- 新闻正文 -->
              <div class="n_r article-wang-editor">
                <div ref="editorRef" style="min-height: 300px;"></div>
              </div>

              <!-- 上一篇下一篇 -->
              <div class="f_y">
                <span>Prev:
                  <a v-if="prevNews" :href="`/news_detail/${prevNews.id}`">{{ prevNews.title }}</a>
                  <a v-else class="disabled">No More...</a>
                </span>
                <span>Next:
                  <a v-if="nextNews" :href="`/news_detail/${nextNews.id}`">{{ nextNews.title }}</a>
                  <a v-else class="disabled">No More...</a>
                </span>
              </div>
            </div>

            <!-- 推荐新闻侧边栏 -->
            <div class="xw_tj">
              <h3 class="tj_title">Recommended News</h3>
              <ul>
                <li v-for="(item, index) in [prevNews, nextNews].filter(Boolean)" :key="index">
                  <a :href="`/news_detail/${item.id}`">
                    <div class="t_p"><img :src="`https://cdn.bosscaigou.com/${item.himg}`" alt=""></div>
                    <div class="w_z">{{ item.title }}</div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 引入图片懒加载指令（可选，优化性能）
// import { directive as lazyLoad } from 'vue-lazyload'
import { infoNew } from '@/api';
import { initTime } from '@/utils/myutils';
import { createEditor, destroyEditor } from '@wangeditor/editor'
import '@wangeditor/editor/dist/css/style.css'
// XSS 过滤库
import DOMPurify from 'dompurify';
export default {
  name: 'NewsDetail',
  directives: {
    // lazy: lazyLoad
  },
  props: {
    // 接收新闻ID（从路由参数获取）
    newsId: {
      type: [String, Number],
      default: 1
    }
  },
  data() {
    return {
      editor: null,
      // 搜索相关
      searchVisible: false,
      searchKeyword: '',
      // 语言下拉框
      languageDropdownVisible: false,
      // 移动端导航
      mobileNavVisible: false,
      // 当前新闻详情数据
      newsDetail: {
        id: 1,
        title: 'Breaking the "double control of carbon emissions and refrigerant emissions" and leading green refrigeration! Shandong Ounal shines at the 20th annual conference of the cold chain logistics industry with new quality technology!',
        publishTime: '2025-04-23',
        source: 'Honor',
        sourceUrl: '',
        bannerImage: 'xq1.jpg',
        content: `
          <p>Recently, the 20th annual conference of the cold chain logistics industry, themed "Optimization Strategy and Redundancy Strategy," kicked off in Jinan. Elites from the cold chain industry across the country gathered to jointly devise a new blueprint for the resilient development of the industry. This annual conference was jointly hosted by the China Cold Chain Alliance, the Cold Chain Logistics Branch of the China Cold Storage Association, and the Cold Storage 100 Information Platform, with Shandong Ounal Refrigeration Technology Co., Ltd. as a co-organizer deeply involved.</p>
          <p><img src="/images/xq2.jpg"></p>
          <p>Among the six high-quality cutting-edge reports released in the "Smart Interaction" session, the special report titled "The Challenges and Solutions for Cold Chain Refrigeration Systems under the New Carbon Emission and Reduction Policy" presented by Qu Luwen, General Manager of Shandong Ounal Refrigeration Technology Co., Ltd., took the lead, sparking deep reflection and enthusiastic responses from the attending guests.</p>
          <p><img src="/images/xq3.jpg"></p>
          <p>The report directly addresses the new challenges and opportunities brought to the cold chain industry by the new policy of "dual control" of total carbon emissions and intensity under the national strategy of "carbon peak and carbon neutrality". It creatively proposes a multi-dimensional approach to response. This is not just a sharing of technical paths, but also provides a set of forward-looking and practical "Oner Solutions" for the industry's transformation and upgrading driven by both policy and market, fully demonstrating Oner's profound understanding and advanced layout of industry policies and technologies.</p>
          <p><img src="/images/xq4.jpg"></p>
          <p>Honor has always firmly believed that technology is the primary driving force behind industry progress. At this annual meeting, Honor was actively involved in multiple core initiatives and joint projects, integrating its technological philosophy into the very essence of industry development.</p>
        `
      },
      // 上一篇新闻
      prevNews: null,
      // 下一篇新闻
      nextNews: {
        id: 2,
        title: 'Passing on love with passion, safeguarding lives through action - Onal Refrigeration employees actively participate in emergency blood donation activities!'
      },
      // 推荐新闻列表
      recommendNews: [
        {
          id: 2,
          image: 'xw2.jpg',
          title: 'Passing on love with passion, safeguarding lives through action - Onal Refrigeration employees actively participate in emergency blood donation activities!'
        },
        {
          id: 3,
          image: 'xw3.jpg',
          title: '"Aoyou Night Party · "Hua" Li New Dimension, this summer is not the same as YOUNG!"!'
        },
        {
          id: 4,
          image: 'xw4.jpg',
          title: 'Remember the revolutionary martyrs and pass on the red gene!'
        },
        {
          id: 5,
          image: 'xw5.jpg',
          title: 'The "Light and Shadow Accompany, Charm Unleashed" Women\'s Day event by Onal came to a successful conclusion, bolstering the box office success of "Nezha"!'
        }
      ]
    }
  },
  mounted() {

    window.scrollTo(0, 0)
    // 1. 从路由参数获取新闻ID（适配Vue Router）
    // if (this.$route && this.$route.params.id) {
    //   this.newsId = this.$route.params.id
    //   // 2. 模拟请求接口获取新闻详情
    //   this.fetchNewsDetail()
    // }

    // 3. 初始化图片懒加载（如需）
    // this.$lazyload({
    //   loading: '/images/loading.png', // 加载中占位图
    //   error: '/images/error.png',     // 加载失败占位图
    //   lazyComponent: true
    // })

    // 4. 调用接口获取新闻详情
    this.infoNewFuc()

    // 滚动监听（可添加回到顶部按钮显隐逻辑）
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    initEditor() {
      // 步骤1：净化富文本内容（防止 XSS 攻击，必做）
      const safeHtml = DOMPurify.sanitize(this.newsDetail.content)

      // 步骤2：创建编辑器实例
      this.editor = createEditor({
        // 挂载的 DOM 元素
        selector: this.$refs.editorRef,
        // 初始内容（HTML 格式）
        html: safeHtml,
        // 配置项：仅展示模式核心配置
        config: {
          readOnly: true, // 关键：设置为只读，禁止编辑
          toolbarConfig: {
            show: false // 隐藏工具栏，仅展示内容
          },
          // 可选：自定义样式/图片处理等
          placeholder: '暂无文章内容',
          // 禁用粘贴/拖拽等交互（仅展示场景）
          enablePasteFilter: true,
          enableDropFile: false
        }
      })

      // 步骤3：渲染编辑器
      // this.editor.render()
    },
    // 初始化时间格式
    initTime(time) {
      return initTime(time)
    },
    async infoNewFuc() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const data = await infoNew({
        id: this.$route.params.id
      })
      loading.close()
      if (data.code == 200) {
        this.newsDetail = data.data
        this.prevNews = data.last
        this.nextNews = data.next
        this.recommendNews = data.data.recommendNews;
        this.$nextTick(() => {
          this.initEditor()
        })
      } else {
        this.$message.error(data.message)
      }
    },
    // ========== 接口请求模拟 ==========

    // ========== 搜索功能 ==========
    toggleSearch() {
      this.searchVisible = !this.searchVisible
      if (this.searchVisible) {
        this.$nextTick(() => {
          const searchInput = document.querySelector('.sc_nr input')
          searchInput?.focus()
        })
      }
    },

    handleSearch() {
      if (!this.searchKeyword.trim()) {
        alert('Please enter search keywords')
        return
      }
      // 跳转到新闻列表页并携带搜索关键词
      this.$router.push({
        path: '/news',
        query: { keyword: this.searchKeyword }
      })
      this.searchVisible = false
    },

    // ========== 语言下拉框 ==========
    toggleLanguage() {
      this.languageDropdownVisible = !this.languageDropdownVisible
    },

    // ========== 移动端导航 ==========
    toggleMobileNav() {
      this.mobileNavVisible = !this.mobileNavVisible
      document.body.style.overflow = this.mobileNavVisible ? 'hidden' : ''
    },

    // ========== 滚动相关 ==========
    handleScroll() {
      // 可添加回到顶部按钮显隐逻辑
      const scrollTop = window.scrollY
      const backToTopBtn = document.querySelector('.f_h')
      if (backToTopBtn) {
        backToTopBtn.style.display = scrollTop > 300 ? 'block' : 'none'
      }
    },

    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style scoped></style>